import { HelmetExtension } from 'abi'

import {
    Font,
    Padding,
    VirtualHeadBox,
    VirtualLabel,
    VirtualTable,
    VirtualTableProps,
} from './virt'
import { hamrah_logo_img, rand, day_stamp_img } from './shared'
import { FONTS } from './shared'

export async function helmet_ext_to_image(ext: HelmetExtension): Promise<Blob> {
    let canvas = document.createElement('canvas')
    const X = 2
    canvas.width = 928 * X
    // canvas.height = canvas.width * Math.SQRT2
    canvas.height = 1280 * X

    const S = Math.sqrt(Math.pow(canvas.width, 2) + Math.pow(canvas.height, 2))

    let ctx = canvas.getContext('2d')!
    if (!ctx) throw new Error('[helmet_to_image] could not get context')

    for (let f of FONTS) {
        ctx.fillText('لود', 100, 100)
        ctx.font = '10px ' + f
        // await document.fonts.ready
    }

    // await document.fonts.ready
    // await new Promise(r => setTimeout(r, 1000))

    // const GKBG = '#00415699'
    // const GHBG = '#1E3C00'
    // const FG = '#f2f2f2'
    // const BG = '#040404'
    // const FG = 'red'

    const GKBG = '#eff9fe'
    const GHBG = '#fff6da'
    const FG = '#000'
    const BG = '#fff'

    ctx.fillStyle = BG
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    let hamrah_logo = document.createElement('img')
    let stamp = document.createElement('img')
    hamrah_logo.src = hamrah_logo_img
    stamp.src = day_stamp_img

    await Promise.all([
        new Promise(r => (hamrah_logo.onload = r)),
        new Promise(r => (stamp.onload = r)),
        document.fonts.ready,
    ])

    let ldw = wp(0.152)

    ldw = wp(0.102)
    let logo_height = (hamrah_logo.naturalHeight / hamrah_logo.naturalWidth) * ldw
    ctx.drawImage(
        hamrah_logo,
        wp(0.74),
        hp(0.020),
        ldw,
        logo_height
    )

    let website = new VirtualLabel({
        color: FG,
        font: { name: 'mono', size: fs(0.5) },
        text: 'hamrah-insurance.com',
        dir: 'ltr',
    })
    website.draw(ctx, wp(0.74) + (ldw - website.width) / 2, hp(0.025) + logo_height)


    let title = new VirtualLabel({
        color: FG,
        font: { name: 'iranBold', size: fs(3.5) },
        text: 'الحاقیه',
        dir: 'ltr',
    })
    title.draw(ctx, (canvas.width - title.width) / 2, hp(0.038))

    function wp(a: number): number {
        return canvas.width * a
    }

    function hp(a: number): number {
        return canvas.height * a
    }

    function fs(a: number): number {
        return ~~(S * (a / 100))
    }

    const GBW = wp(0.349)
    const GBLW = wp(0.001)
    const GRGAP = hp(0.01)

    const GHFONT: Font = { size: fs(0.9), name: 'b-nazanin', bold: true }
    const GRFONT: Font = { size: fs(0.7), name: 'b-nazanin' }

    // const GBHSW = GBW / 2 + wp(0.018)

    const GPAD: Padding = {
        top: hp(0.005),
        bottom: hp(0.005),
        left: wp(0.003),
        right: wp(0.003),
    }

    const LY = hp(0.116)
    const RY = hp(0.116)
    const RX = wp(0.502)
    const LX = wp(0.128)

    const VTD: Omit<VirtualTableProps, 'header' | 'rows'> = {
        line_width: GBLW,
        width: GBW,
        color: FG,
        hfont: GHFONT,
        kfont: GRFONT,
        center_value: true,
        vfont: GRFONT,
        hbg: GHBG,
        hpad: GPAD,
        vpad: GPAD,
        kpad: GPAD,
        kbg: GKBG,
    }

    let vl1 = new VirtualTable({
        ...VTD,
        header: 'مشخصات بیمه نامه',
        rows: [
            [
                'شماره بیمه نامه',
                `${ext.issue_year}/31/${ext.issuer_code}/${ext.insurance_number}`,
            ],
            ['تاریخ شروع', ext.start_date],
            ['تاریخ پایان', ext.expiration_date],
            ['واحد صدور', ext.issuer],
            ['تاریخ صدور', ext.issue_date],
            ['نمایندگی', ext.reagent],
        ],
    })
    vl1.draw(ctx, LX, LY)

    let vl2 = new VirtualTable({
        ...VTD,
        header: 'مشخصات الحاقیه',
        rows: [
            ['کد داخلی', ext.ext_code.toLocaleString()],
            ['ردیف', `${ext.ext_row} / ${ext.ext_number}`],
            ['تاریخ اثر', ext.apply_date],
            ['تاریخ صدور الحاقیه', ext.ext_issue_date],
            ['شماره الحاقیه', ext.ext_number.toLocaleString()],
            ['نوع تغییر', ext.ext_change],
            ['شرح تغییر', ext.transaction_detail],
            [
                'نوع / خلاصه تراکنش',
                ext.transaction_kind + ' / ' + ext.transaction_summary,
            ],
        ],
    })
    vl2.draw(ctx, LX, LY + vl1.height + GRGAP)

    let vl3 = new VirtualHeadBox({
        header: 'مهر و امضا صادرکننده',
        vpad: { top: hp(0.003), bottom: hp(0.003), right: wp(0.005) },
        // text: 'مرکزی\nشماره بیمه\nشماره اقتصادی',
        text: `\n\n\n\n\n\n\n\n\n\n\nنام و کد معرف: ${ext.reagent}`,
        vfont: { size: fs(0.75), name: 'b-nazanin' },
        color: FG,
        width: GBW,
        hpad: { top: hp(0.004), bottom: hp(0.004) },
        hbg: GHBG,
        hfont: GHFONT,
        line_width: GBLW,
    })
    vl3.draw(ctx, LX, LY + vl1.height + vl2.height + GRGAP * 2)

    ctx.save()

    ldw = wp(0.18)
    let stamp_x = LX + (vl3.width - ldw) / 2 + rand(wp(-0.05), wp(0.05))
    let stamp_y =
        LY + hp(0.009) + vl3.header_height + vl1.height + vl2.height + GRGAP * 2

    let stamp_height = (stamp.naturalHeight / stamp.naturalWidth) * ldw
    ctx.translate(stamp_x + ldw / 2, stamp_y + stamp_height / 2)
    ctx.rotate((rand(-5, 5) * Math.PI) / 180)
    ctx.drawImage(stamp, -(ldw / 2), -(stamp_height / 2), ldw, stamp_height)
    ctx.restore()

    //////////////////////////////

    let vr1 = new VirtualTable({
        ...VTD,
        center_value: false,
        header: 'بیمه گذار',
        rows: [
            ['نام بیمه گذار', ext.insurer],
            ['شماره اقتصادی', ext.economic_number + ''],
            ['تلفن بیمه گذار', ext.insurer_phone + ''],
        ],
    })
    vr1.draw(ctx, RX, RY)

    let vr2 = new VirtualTable({
        ...VTD,
        header: 'مشخصات خودرو',
        rows: [
            ['شماره شاسی وسیله نقلیه', ext.chassis],
            ['شماره موتور وسیله نقلیه', ext.engine],
            [
                'شماره انتظامی وسیله نقلیه',
                ext.plate_number +
                    ' ' +
                    ext.plate_city +
                    ' ' +
                    ext.plate_serial,
            ],
            ['شماره VIN وسیله نقلیه', ext.vin],
            ['سیستم وسیله نقلیه', ext.v_system],
            ['ظرفیت وسیله نقلیه', ext.passenger_count + ' نفر'],
            ['نوع وسیله نقلیه', ext.v_name],
            ['کاربری وسیله نقلیه', ext.v_usage],
            ['سال ساخت', ext.manufacture_year + ''],
        ],
    })
    vr2.draw(ctx, RX, RY + vr1.height + GRGAP)

    let vr3 = new VirtualTable({
        ...VTD,
        header: 'تعهد بیمه نامه',
        rows: [
            [
                'تعهد مالی بیمه شخص ثالث',
                ext.airrm_cover_financial.toLocaleString() + ' میلیون ریال',
            ],
            [
                'تعهد بدنی بیمه شخص ثالث',
                ext.airrm_cover_life.toLocaleString() + ' میلیون ریال',
            ],
            [
                'تعهد بدنی بیمه حوادث راننده',
                ext.airrm_cover_passenger.toLocaleString() + ' میلیون ریال',
            ],
        ],
    })
    vr3.draw(ctx, RX, RY + vr1.height + vr2.height + GRGAP * 2)

    let vr4 = new VirtualTable({
        ...VTD,
        header: 'حق بیمه (ریال)',
        rows: [
            [
                'حق بیمه شخص ثالث',
                ext.third_party_insurance_amount.toLocaleString(),
            ],
            [
                'حق بیمه حوادث راننده',
                ext.passenger_insurance_amount.toLocaleString(),
            ],
            [
                'حق بیمه پوشش مازاد مالی',
                ext.financial_surplus_insurance_amount.toLocaleString(),
            ],
            [
                'حق بیمه پوشش مازاد حوادث راننده',
                ext.life_surplus_insurance_amount.toLocaleString(),
            ],
            ['جریمه صندوق', ext.fund_fine.toLocaleString()],
            [
                'مالیات و عوارض ارزش افزوده',
                (ext.added_tax + ext.added_toll).toLocaleString(),
            ],
            ['درصد تخفیف بیمه شخص ثالث', ''],
            ['درصد تخفیف بیمه حوادث راننده', ''],
            ['مبلغ تخفیفات', ''],
            ['نحوه پرداخت حق بیمه', 'نقط و اقساط'],
            [
                'کل مبلغ حق بیمه',
                (
                    ext.total_insurance_amount +
                    ext.added_tax +
                    ext.added_toll
                ).toLocaleString(),
            ],
        ],
    })
    vr4.draw(ctx, RX, RY + vr1.height + vr2.height + vr3.height + GRGAP * 3)

    let blob = await new Promise<Blob | null>(r =>
        canvas.toBlob(r, 'image/png')
    )
    if (!blob) {
        throw new Error('[helmet_to_image] could not get do canvas.toBlob')
    }

    return blob
}
